import { Route, Routes } from "react-router";

import { AuditPage } from "../diagnostics/pages/AuditPage";
import { DiagnosticsPage } from "../diagnostics/pages/DiagnosticsPage";
import { RunbookPage } from "../diagnostics/pages/RunbookPage";
import { OperationsPage } from "./pages/OperationsPage";

/**
 * The operations routes, mounted at `/operations/*`. The index is the queues and the jobs of the background work (CHT-761). CHT-772 adds, beside
 * it: `diagnostics` (provider health, failed jobs, payment problems, notification failures, with the supported recovery actions), `audit` (the
 * audit trail) and `runbooks/:slug` (the operational runbooks).
 */
export function OperationsRoutes() {
  return (
    <Routes>
      <Route index element={<OperationsPage />} />
      <Route path="diagnostics" element={<DiagnosticsPage />} />
      <Route path="audit" element={<AuditPage />} />
      <Route path="runbooks" element={<RunbookPage />} />
      <Route path="runbooks/:slug" element={<RunbookPage />} />
    </Routes>
  );
}
